export const breadcrumb = {
  stats: {
    title: 'Statistik',
    general: 'Umum',
    detailed: 'Detail'
  }
};

